import axios, { AxiosResponse } from "axios";
import type {
  LoginPasswordForgottenPostPayload,
  LoginPasswordResetPostPayload,
  LoginPostPayload,
} from "@qivia/schemas-office";
import { axiosInstanceNoAuth } from "../../utils";
export type LoginAPI = LoginPostPayload;

export type PasswordForgottenAPI = LoginPasswordForgottenPostPayload;

export type PasswordResetAPI = LoginPasswordResetPostPayload;

export interface PasswordCreationAPI {
  password: string;
  managerId: string;
}

export type LastCreatedPasswordRequest = {
  lastCreatedPasswordRequest: {
    expirationDate: string;
    canceledAt: string | null;
    registeredAt: string | null;
  } | null;
};

export const loginCall = async (payload: LoginAPI) => {
  const BACKEND_URL = import.meta.env["VITE_BACKEND_URL"] as string;
  return await axios.post<{ token: string }>(
    `${BACKEND_URL}/office/login`,
    payload,
  );
};

export const loginPasswordForgottenCall = async (
  payload: PasswordForgottenAPI,
): Promise<AxiosResponse<{ errorMessage?: string }>> => {
  const axiosInstance = axiosInstanceNoAuth();
  const response = await axiosInstance.post<{ errorMessage?: string }>(
    `/login_password_forgotten`,
    payload,
  );
  return response;
};

export const loginPasswordResetCall = async (payload: PasswordResetAPI) => {
  const axios = axiosInstanceNoAuth();
  return await axios.post(`/login_password_reset`, payload);
};
